import getCanadaProvince from "api/checkout/getCanadaProvince";
import { useTranslation } from "next-i18next";
import { useState, useEffect } from "react";
import { POSTAL_CODE_REGEX } from "../../../util/helper/helper";
import { maskText } from "../../../util/lodash/maskText";
import Input from "../../formsy-components/input";
import styles from "./postalCodeInput.module.scss";

function getMaskedInputValue(dataString = "") {
  const value = (dataString && dataString.replace(/\s/g, "")) || "";
  return maskText(value, 3);
}

function PostalCodeInput(props: any) {
  const {
    defaultValue, validations, validationErrors, setProvince, floatingLabel = false, ...rest
  } = props;
  const [postalCode, setPostalCode] = useState();
  const { t } = useTranslation("common");

  useEffect(() => {
    setPostalCode(defaultValue);
  }, [defaultValue]);

  return (
    <div className={styles.postal_code_input}>
      <Input
        onChange={(name: any, value: any) => {
          setPostalCode(value);
          if (props.onChange) {
            props.onChange();
          }
        }}
        name="postalCode"
        id="postalCode"
        type="text"
        style={{ zIndex: "unset" }}
        label={`${t("Postal Code")}`}
        value={getMaskedInputValue(postalCode)}
        maxLength={7}
        validations={{
          matchRegexp: POSTAL_CODE_REGEX,
          maxLength: 7,
          matchesProvince: (values: any, value: any) => {
            const province = getCanadaProvince(value);
            if (province && values.state) {
              if (values.state === province) {
                return true;
              }
              if (setProvince) {
                setProvince(province);
              }
              return false;
            } if (province && !values.state && setProvince) {
              // set province in values.state
              setProvince(province);
            }
            return true;
          },
          ...validations,
        }}
        validationErrors={{
          matchRegexp: t("postal_code_validation"),
          matchesProvince:
            t("province_validation"),
          ...validationErrors,
        }}
        floatingLabel={floatingLabel}
        required
        hideRequiredSymbol
        {...rest}
      />
    </div>
  );
}

export default PostalCodeInput;
